<div
  #cardRoot
  class="card grouped-bar-status-card"
  *ngIf="data"
>
  <div class="card-header grouped-bar-status-header">
    <div class="card-title title-block">
      <h4>{{ currentTitle }}</h4>
      <p *ngIf="currentSubtitle">{{ currentSubtitle }}</p>
    </div>

    <div class="view-tabs" *ngIf="viewTabs.length > 1" role="tablist" aria-label="Chart views">
      <button
        type="button"
        *ngFor="let tab of viewTabs; let index = index"
        class="view-tab"
        [class.active]="index === activeViewIndex"
        (click)="selectView(index)"
      >
        {{ tab.label }}
      </button>
    </div>
  </div>

  <div class="chart-shell">
    <div
      #plotScroll
      class="plot-scroll"
      [class.fit-to-width]="fitToWidth"
      [style.--plot-min-width.px]="plotMinWidth"
      [style.--category-area-width.px]="categoryAreaWidth"
      [style.--label-column-width.px]="labelColumnWidth"
      [style.--grid-right-width.px]="gridRightWidth"
    >
      <div #chartHost class="chart-host"></div>

      <div class="status-table" *ngIf="statusMatrix.length && categoryCount > 0">
        <div class="status-row" *ngFor="let row of statusMatrix">
          <div class="status-label">{{ row.label }}</div>
          <div class="status-track" [style.grid-template-columns]="statusGridTemplate">
            <div
              *ngFor="let cell of row.cells"
              class="status-cell"
              [class.active]="isCategorySelected(cell.category)"
            >
              <span class="status-pill" [ngStyle]="getStatusStyle(cell.value)">{{ cell.label }}</span>
            </div>
          </div>
          <div class="status-end-spacer"></div>
        </div>
      </div>

      <div class="status-chart-pager" *ngIf="hasPagedScroller">
        <span>{{ pageStartIndex + 1 }}-{{ pageEndIndex }}</span>
        <input
          class="status-chart-slider"
          type="range"
          min="0"
          [max]="pagerMax"
          step="1"
          [value]="pageStartIndex"
          (input)="onPageStartChange($event)" />
        <span>{{ pageStartIndex + 1 }}-{{ pageEndIndex }} of {{ pageRowCount }}</span>
      </div>
    </div>
  </div>
</div>
